import * as Dialog from "@radix-ui/react-dialog";
import styled from "styled-components";
import Globo from "../../assets/Globo/Globo";
import Styleguide, { Colors, theme } from "../../theme";

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 24px 24px 40px 24px;

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    margn-bottom: 64px;
  }
`;

export const ContaGloboLogo = styled(Globo)`
  width: 140px;

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    width: 160px;
  }
`;

export const EmailSpan = styled.span`
  font-family: ${Styleguide.fonts.heading.name};
  font-weight: ${Styleguide.fontWeights.regular};
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const UserMenu = styled.div`
  display: none;
  position: absolute;
  width: 30%;
  justify-content: right;
  color: currentColor;
  align-items: center;
  right: 0;
  white-space: nowrap;

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    display: flex;
  }
`;

export const OpenUserMenu = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  text-align: right;
  padding: 15px;
  margin: 15px 0 0;
  top: 20px;
  right: 5px;
  border: 1px solid #f1f1f1;

  font-weight: ${Styleguide.fontWeights.bold};
  font-family: ${Styleguide.fonts.body};
  font-size: 14px;
  line-height: 22px;

  background-color: ${theme(Colors.white, Colors.gray[400])};
  color: ${theme(Colors.blue[100], Colors.gray[100])};

  > span {
    font-size: 18px;
    font-weight: ${Styleguide.fontWeights.semibold};
    color: ${theme(Colors.gray[400], Colors.gray[100])};
    margin-bottom: 8px;
  }

  > button {
    margin: 0 0 0 5px;
    color: ${theme(Colors.blue[100], Colors.lightBlue[100])};
    text-decoration: none;
    background: none;
    border: none;
    text-align: right;
    font-size: ${Styleguide.fontSizes[14]};
    font-family: ${Styleguide.fonts.body};
    font-weight: ${Styleguide.fontWeights.bold};
    cursor: pointer;
  }
`;

export const UserButton = styled(Dialog.Trigger)`
  display: flex;
  justify-content: flex-end;
  background: none;
  border: none;
  cursor: pointer;
  color: ${theme(Colors.blue[100], Colors.gray[100])};
  width: auto;
  text-overflow: ellipsis;
  overflow: hidden;

  > svg {
    margin: 0 5px;
  }

  &[data-state="open"] svg:first-of-type {
    display: none;
  }

  &[data-state="closed"] svg:last-of-type {
    display: none;
  }
`;
